import type { DataGridProProps } from '@packages/fenrir/components/datagrid';

export const paginationConfig = {
  assetProfile: {
    pageSize: 10,
    options: [10, 20, 50, 100],
  },
  assetsList: {
    pageSize: 50,
    options: [10, 20, 50, 100],
  },
};

export const commonSlotProps: DataGridProProps['slotProps'] = {
  loadingOverlay: {
    variant: 'skeleton',
    noRowsVariant: 'skeleton',
  },
  pagination: {
    showFirstButton: true,
    showLastButton: true,
  },
};

export const FILTER_DEBOUNCE_MS = 500;
